import React, { useState, useEffect } from "react";
import IsLoading from "./IsLoading";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const SoundChartsPageBarTypeLEQ = ({
  chartLabels,
  chartData,
  soundDataType,
  parameter,
  count,
  loading,
}) => {
  const [currentChartTitleText, setCurrentChartTitleText] =
    useState("سطح فشار صدا (SPL)");
  const [currentChartDataBasedOnLeq, setCurrentChartDataBasedOnLeq] = useState(
    []
  );
  const [currentChartColors, setCurrentChartColors] = useState([]);
  const [currentChartDataStatus, setCurrentChartDataStatus] = useState([]);

  const setTheColorOfLeq = (leq) => {
    if (leq === null) return "#8f8f8f"; // Grey for null values

    if (soundDataType === "nighttime") {
      if (leq <= 50) return "#0f9d63";
      if (leq > 50 && leq <= 55) return "#ffd700";
      if (leq > 55 && leq <= 60) return "#ff8c00";
      if (leq > 60) return "#ff0000";
    } else {
      if (leq <= 60) return "#0f9d63";
      if (leq > 60 && leq <= 65) return "#ffd700";
      if (leq > 65 && leq <= 70) return "#ff8c00";
      if (leq > 70) return "#ff0000";
    }
    return "#8f8f8f"; // Default grey
  };

  const setTheStatusOfLeq = (leq) => {
    if (leq === null) return "نامعلوم";

    if (soundDataType === "nighttime") {
      if (leq <= 50) return "مناسب";
      if (leq > 50 && leq <= 55) return "نامناسب برای گروه های حساس";
      if (leq > 55 && leq <= 60) return "آزار دهنده";
      if (leq > 60) return "خطرناک";
    } else {
      if (leq <= 60) return "مناسب";
      if (leq > 60 && leq <= 65) return "نامناسب برای گروه های حساس";
      if (leq > 65 && leq <= 70) return "آزار دهنده";
      if (leq > 70) return "خطرناک";
    }
    return "نامعلوم"; // Default status
  };

  useEffect(() => {}, [
    soundDataType,
    parameter,
    count,
    chartData,
    chartLabels,
  ]);
  console.log(count);

  useEffect(() => {
    const titles = {
      online: "سطح فشار صدا (SPL)",
      hourly: "تراز معادل مواجهه صوت ساعتی",
      daytime: "تراز معادل مواجهه صوت روزانه",
      nighttime: "تراز معادل مواجهه صوت شبانه",
      daily: "تراز معادل مواجهه صوت شبانه روز",
    };
    setCurrentChartTitleText(titles[soundDataType] || "سطح فشار صدا (SPL)");

    if (!chartData) return;

    let selectedParameter;
    if (soundDataType === "spl") {
      selectedParameter = "spl";
    } else {
      if (parameter === "leq_min") {
        selectedParameter = "leq_min";
      } else if (parameter === "leq_max") {
        selectedParameter = "leq_max";
      } else {
        selectedParameter = "leq";
      }
    }

    const leqData = chartData.map((data) => data[selectedParameter] ?? null);
    const leqColors = leqData.map(setTheColorOfLeq);
    const leqStatus = leqData.map(setTheStatusOfLeq);

    setCurrentChartDataBasedOnLeq(leqData);
    setCurrentChartColors(leqColors);
    setCurrentChartDataStatus(leqStatus);
  }, [count, loading]);

  const data = {
    labels: chartLabels ?? [],
    datasets: [
      {
        data: currentChartDataBasedOnLeq ?? [],
        backgroundColor: currentChartColors ?? [],
        borderColor: currentChartColors ?? [],
        borderWidth: 1,
        minBarThickness: 10,
        maxBarThickness: 30,
      },
    ],
  };

  return (
    <div className="bg-white p-3 rounded shadow-lg mx-auto">
      {loading ? (
        <IsLoading className="mx-auto" />
      ) : (
        <>
          <h5 className="text-center my-3">{currentChartTitleText}</h5>
          <Bar
            style={{ width: "100%" }}
            className="mx-auto my-4"
            data={data}
            options={{
              responsive: true,
              scales: { x: { stacked: true }, y: { stacked: true } },
              plugins: {
                title: { display: false },
                legend: { display: false },
                tooltip: {
                  enabled: false,
                  callbacks: {
                    label: function (tooltipItem) {
                      if (Array.isArray(currentChartDataStatus)) {
                        const soundValue = tooltipItem.raw;
                        const status =
                          currentChartDataStatus[tooltipItem.dataIndex] ||
                          "نامعلوم";
                        return `داده: ${soundValue} (${status})`;
                      }
                    },
                  },
                  boxPadding: 0,
                  boxWidth: 0,
                  boxHeight: 0,
                },
                datalabels: {
                  display: false, // Ensure data labels are hidden if datalabels plugin is used
                },
              },
            }}
          />
        </>
      )}
    </div>
  );
};

export default SoundChartsPageBarTypeLEQ;
